if (!customElements.get('service-body-vehicle')) {
  customElements.define('service-body-vehicle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.pendingVariantId = null;
      this.config = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.form = document.getElementById(this.dataset.productForm);
      this.make = this.querySelector('[data-vehicle-make]');
      this.model = this.querySelector('[data-vehicle-model]');
      this.year = this.querySelector('[data-vehicle-year]');
      this.status = this.querySelector('[data-vehicle-status]');
      this.sku = this.querySelector('[data-vehicle-sku]');
      this.trundle = this.form.querySelector('[data-extras-trundle]');
      this.waterTank = this.form.querySelector('[data-extras-water]');
      this.wheelGuards = this.form.querySelector('[data-extras-wheel-guards]');
      this.extrasStatus = this.form.querySelector('[data-extras-status]');
      this.extrasTotal = this.form.querySelector('[data-extras-total]');
      this.variant = this.config.variants.find(v => String(v.id) === String(this.config.selectedVariantId));
      this.optionIndex = this.config.optionNames.indexOf('Under tray toolbox');
      this.configuration = this.variant?.options.slice();
      this.section = this.closest('.js-product') || this.closest('article') || this.form;
      this.nativeRefresh = !this.config.preorder && this.section.matches('.m6pr, .m6pr-compact');
      this.renderedVariantId = String(this.config.selectedVariantId);
      const makes = [...new Set(this.config.fitments.map(row => row.make))].sort();
      this.fill(this.make, makes);
      this.changeHandler = event => {
        if (event.target === this.make) {
          this.fill(this.model, this.config.fitments.filter(row => row.make === this.make.value).map(row => row.model));
          this.fill(this.year, []);
        } else if (event.target === this.model) this.fillYears();
        this.sync();
      };
      this.addEventListener('change', this.changeHandler);
      this.nativeHandler = event => {
        if (this.contains(event.target)) return;
        if (event.target === this.trundle || event.target === this.waterTank || event.target === this.wheelGuards) {
          const removed = this.trundle.value === '1500' && this.waterTank.value === 'true';
          this.syncExtras(removed);
          this.sync();
          return;
        }
        const control = event.target.closest('[data-vehicle-bundle-option]');
        if (control && (control.type !== 'radio' || control.checked)) {
          const index = Number(control.dataset.vehicleBundleOption);
          if (index !== this.optionIndex && this.configuration) this.configuration[index] = control.value;
          this.sync();
        } else if (event.target.name === 'id' && event.target.form === this.form) {
          if (this.dispatchingNative) return;
          const variant = this.config.variants.find(v => String(v.id) === String(event.target.value));
          if (variant) this.configuration = variant.options.slice();
          if (this.nativeRefresh) {
            event.stopImmediatePropagation();
            this.sync();
          } else {
            if (variant) this.variant = variant;
            this.sync();
          }
        }
      };
      this.section.addEventListener('change', this.nativeHandler, { capture: true });
      this.renderHandler = () => {
        if (!this.nativeRefresh || this.form.classList.contains('processing')) return;
        if (this.pendingVariantId) {
          window.clearTimeout(this.refreshTimer);
          this.pendingVariantId = null;
          this.renderedVariantId = String(this.form.elements.namedItem('id')?.value || '');
        }
        this.sync();
      };
      window.addEventListener('productVariants', this.renderHandler);
      this.submitHandler = event => {
        this.sync();
        if (!this.valid && !this.legacyAttempt()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          (this.make.value ? (this.model.value ? this.year : this.model) : this.make).focus();
        }
      };
      this.form.addEventListener('submit', this.submitHandler, { capture: true });
      this.form.addEventListener('click', this.clickHandler = event => {
        if (event.target.closest('[data-service-body-preorder]')) this.submitHandler(event);
      }, { capture: true });
      try {
        const attempt = JSON.parse(sessionStorage.getItem(`service-body-checkout:v1:${this.config.bundleHandle}`) || 'null');
        const saved = attempt && JSON.parse(attempt.selection);
        const vehicle = saved?.vehicle;
        if (this.trundle && ['1000', '1500'].includes(saved?.extras?.trundle)) this.trundle.value = saved.extras.trundle;
        if (this.waterTank) this.waterTank.value = saved?.extras?.waterTank === true ? 'true' : 'false';
        if (this.wheelGuards && ['standard', 'wide'].includes(saved?.extras?.wheelGuards)) this.wheelGuards.value = saved.extras.wheelGuards;
        if (vehicle && makes.includes(vehicle.make)) {
          this.make.value = vehicle.make;
          this.fill(this.model, this.config.fitments.filter(row => row.make === vehicle.make).map(row => row.model));
          this.model.value = vehicle.model;
          this.fillYears();
          this.year.value = String(vehicle.year);
        }
      } catch (_) {}
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.changeHandler);
      this.section?.removeEventListener('change', this.nativeHandler, { capture: true });
      window.removeEventListener('productVariants', this.renderHandler);
      window.clearTimeout(this.refreshTimer);
      this.form?.removeEventListener('submit', this.submitHandler, { capture: true });
      this.form?.removeEventListener('click', this.clickHandler, { capture: true });
      this.ready = false;
    }

    fill(select, values) {
      select.replaceChildren(new Option(select.dataset.placeholder, ''), ...values.map(value => new Option(String(value), String(value))));
      select.disabled = values.length === 0;
    }

    row() {
      return this.config.fitments.find(row => row.make === this.make.value && row.model === this.model.value);
    }

    fillYears() {
      const row = this.row();
      const current = new Date().getUTCFullYear();
      const years = [];
      if (row?.size) for (let year = Math.min(row.to || current, current); year >= (row.from || 1900); year--) years.push(year);
      this.fill(this.year, years);
    }

    legacyAttempt() {
      return this.form.querySelector('[data-service-body-preorder]')?.dataset.resumeLegacy === 'true';
    }

    selection() {
      this.sync();
      if (!this.valid) throw new Error('selection_error');
      return { make: this.make.value, model: this.model.value, year: Number(this.year.value) };
    }

    writeNative(selected) {
      for (const control of this.section.querySelectorAll('[data-vehicle-bundle-option]')) {
        const value = selected.options[Number(control.dataset.vehicleBundleOption)];
        if (control.type === 'radio') control.checked = control.value === value;
        else control.value = value;
      }
      for (const control of Array.from(this.form.elements).filter(element => element.name === 'id')) {
        if (control.type === 'radio') control.checked = String(control.value) === String(selected.id);
        else control.value = selected.id;
      }
    }

    refresh(selected) {
      const control = Array.from(this.form.elements).find(element => element.name === 'id' && element.tagName === 'SELECT');
      if (!control?.classList.contains('listening')) return;
      this.pendingVariantId = String(selected.id);
      this.form.classList.add('processing');
      this.dispatchingNative = true;
      try { control.dispatchEvent(new Event('change', { bubbles: true })); }
      finally { this.dispatchingNative = false; }
      this.refreshTimer = window.setTimeout(() => {
        this.pendingVariantId = null;
        this.status.textContent = this.config.messages.unavailable;
      }, 30000);
    }

    updatePrice(variant) {
      if (!this.config.preorder || !this.trundle || typeof variant.priceHtml !== 'string') return;
      const scope = this.closest('.shopify-section') || this.section;
      for (const price of scope.querySelectorAll('.product-info__price > .price, sticky-atc-panel .price')) {
        const current = price.querySelector('.price__default .price__current');
        const previous = price.querySelector('.price__was');
        if (current) current.innerHTML = variant.priceHtml;
        if (previous) previous.innerHTML = variant.compareAtPriceHtml || '';
        price.classList.toggle('price--on-sale', variant.compareAtPrice > variant.price);
        for (const from of price.querySelectorAll('.price__from')) from.hidden = true;
      }
    }

    syncExtras(removed = false) {
      if (!this.trundle || !this.waterTank) return;
      const longer = this.trundle.value === '1500';
      if (longer) this.waterTank.value = 'false';
      this.waterTank.querySelector('[value="true"]').disabled = longer;
      if (this.extrasStatus) this.extrasStatus.textContent = this.extrasStatus.dataset[removed ? 'removed' : 'fit'];
    }

    sync() {
      if (this.trundle && this.waterTank) {
        const longer = this.trundle.value === '1500';
        if (longer) this.waterTank.value = 'false';
        this.waterTank.querySelector('[value="true"]').disabled = longer;
      }
      const row = this.row();
      const year = Number(this.year.value);
      const supported = row?.size && Number.isSafeInteger(year)
        && year >= (row.from || 1900) && year <= Math.min(row.to || new Date().getUTCFullYear(), new Date().getUTCFullYear());
      const extrasSuffix = (this.trundle?.value === '1500' ? ' / 1500mm Trundle'
        : this.waterTank?.value === 'true' ? ' / 40L Water Tank' : '')
        + (this.wheelGuards?.value === 'wide' ? ' / Wide Offset Wheel Guards' : '');
      const matches = supported && this.optionIndex >= 0 && this.configuration
        ? this.config.variants.filter(v => v.options[this.optionIndex] === `${row.size}mm${extrasSuffix}`
          && v.options.every((value, index) => index === this.optionIndex || value === this.configuration[index]))
        : [];
      const selected = matches.length === 1 ? matches[0] : null;
      if (selected && this.nativeRefresh) {
        this.writeNative(selected);
        if (!this.pendingVariantId && String(selected.id) !== this.renderedVariantId) this.refresh(selected);
      }
      const renderedAvailability = this.nativeRefresh
        ? this.form.querySelector('[data-vehicle-checkout]')?.dataset.vehicleAvailable
        : undefined;
      const available = renderedAvailability === undefined ? selected?.available : renderedAvailability === 'true';
      this.valid = !!selected && (this.config.preorder || available)
        && !this.pendingVariantId && (!this.nativeRefresh || String(selected.id) === this.renderedVariantId);
      const initial = this.config.variants.find(v => String(v.id) === String(this.config.selectedVariantId));
      const priceSize = initial?.options[this.optionIndex]?.split(' / ')[0];
      const priceVariant = selected || this.config.variants.find(v => v.options[this.optionIndex] === `${priceSize}${extrasSuffix}`
        && v.options.every((value, index) => index === this.optionIndex || value === this.configuration?.[index]));
      if (priceVariant) this.updatePrice(priceVariant);
      if (this.extrasTotal) this.extrasTotal.textContent = priceVariant
        ? this.extrasTotal.dataset.total.replace('{amount}', new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(priceVariant.price / 100))
        : this.extrasTotal.dataset.choose;
      this.sku.value = this.valid ? `AS-TUTT-V2-${row.size}-B` : '';
      this.status.textContent = this.pendingVariantId ? (this.config.messages.checking || this.config.messages.choose)
        : row && !row.size ? this.config.messages.unconfirmed
        : !supported ? this.config.messages.choose
        : !selected ? this.config.messages.unavailable
        : !this.valid ? this.config.messages.sold_out
        : this.config.messages.matched.replace('{size}', row.size);
      if (this.valid) {
        this.variant = selected;
        this.writeNative(selected);
      }
      for (const button of this.form.querySelectorAll('[data-vehicle-checkout]')) {
        if (button.getAttribute('aria-busy') !== 'true') button.disabled = !this.valid && !this.legacyAttempt();
      }
    }
  });
}
